import { render, staticRenderFns } from "./terrestrialWildlife.vue?vue&type=template&id=2396eafa&scoped=true&"
import script from "./terrestrialWildlife.vue?vue&type=script&lang=js&"
export * from "./terrestrialWildlife.vue?vue&type=script&lang=js&"
import style0 from "./terrestrialWildlife.vue?vue&type=style&index=0&id=2396eafa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396eafa",
  null
  
)

export default component.exports